export default {"src":"/_next/static/media/greenways.7df9d379.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};